import type { FC } from 'react'

import { useTranslation } from '@/app/translations/translations-hooks'
import Highlight from '@/components/Highlight'
import { useFormattedNumberWithCurrency } from '@/hooks/use-formatted-number-with-currency'
import { useLocalDate } from '@/hooks/use-local-date'
import type { TradeInOrder } from '@/modules/admin/resources'

import { Actions } from './Actions'

export const OrderListItem: FC<
  { searchFilter: string; showActionsCol: boolean; orderCustomerId: number } & TradeInOrder
> = ({
  searchFilter,
  showActionsCol,
  orderCustomerId,
  orderId,
  productName,
  orderStatus,
  assetDate,
  grade,
  estimatedPrice,
  finalGrade,
  finalPrice,
  imeiSerialNumber,
}) => {
  const translate = useTranslation()
  const { formatNumber } = useFormattedNumberWithCurrency()
  const { formatDate } = useLocalDate()
  const isPriceEstOrAccept = orderStatus === 'PRICE_ESTIMATION' || orderStatus === 'ACCEPTANCE'

  return (
    <tr>
      <td>
        <div className="flex flex-col">
          <Highlight pattern={searchFilter} text={productName || ''} />
          <span className="mt-1 text-xs text-zinc-500">
            <Highlight pattern={searchFilter} text={imeiSerialNumber || ''} />
          </span>
        </div>
      </td>

      <td className="hidden md:table-cell">
        <Highlight pattern={searchFilter} text={formatDate({ date: assetDate })} />
      </td>

      <td className="hidden md:table-cell">
        <Highlight pattern={searchFilter} text={grade ?? '-'} />
      </td>

      <td className="hidden md:table-cell">
        <Highlight
          pattern={searchFilter}
          text={formatNumber({ amount: estimatedPrice ?? 0 }) ?? '-'}
        />
      </td>

      <td className="hidden md:table-cell">
        <Highlight pattern={searchFilter} text={finalGrade ?? '-'} />
      </td>

      <td className="hidden md:table-cell">
        <Highlight pattern={searchFilter} text={formatNumber({ amount: finalPrice ?? 0 }) ?? '-'} />
      </td>

      <td className="whitespace-normal break-words">
        <Highlight
          pattern={searchFilter}
          text={translate(`trade_in_order_status/${orderStatus}`)}
        />
      </td>
      {showActionsCol && (
        <td>
          {isPriceEstOrAccept && (
            <Actions orderStatus={orderStatus} orderId={orderId} customerId={orderCustomerId} />
          )}
        </td>
      )}
    </tr>
  )
}
